import { render } from "./Movie.vue?vue&type=template&id=7498021c&scoped=true"
import script from "./Movie.vue?vue&type=script&lang=js"
export * from "./Movie.vue?vue&type=script&lang=js"

import "./Movie.vue?vue&type=style&index=0&id=7498021c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7498021c"]])

export default __exports__